import { config } from "@app-contexts/sdk/services/config";
import {
  Widget,
  type WidgetLaunchOptions,
  WidgetQueryParams,
} from "@app-contexts/sdk/services/Widget";

import { checkoutWidget, prepareWidgetParams } from "./checkout";
import {
  getCustomerAttributionWidgetOptions,
  getEmbeddedWidgetCallArgs,
  getEmbeddedWidgetOptions,
} from "./embedded-widget-options";

/**
 * Shows a product purchase widget for the specified event
 * @param id id of product
 * @param params values to add to URL params (e.g. 'theme_primary', 'theme_secondary', etc.)
 * @param containerId id of the container to embed the widget in
 * @param options optional host callback used to refresh a rejected attribution token
 */
export async function productPurchaseWidget(
  id: string,
  params: WidgetQueryParams,
  containerId?: string,
  options: WidgetLaunchOptions = {}
) {
  const enrichedParams = prepareWidgetParams(params);

  const widget = new Widget({
    src: await config.productPurchaseWidgetUrl(id),
    containerId,
    queryParams: enrichedParams,
    ...getEmbeddedWidgetOptions(containerId),
    ...getCustomerAttributionWidgetOptions(enrichedParams, options),
  });

  widget.show().on("showpass.product-purchase.checkout", () => {
    widget.close({ removeBodyClass: false });
    checkoutWidget(
      enrichedParams,
      ...getEmbeddedWidgetCallArgs(containerId, options)
    );
  });

  return widget;
}
